import * as React from "react";
const SvgFiRrLockHashtag = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-lock-hashtag_svg__a)">
      <path
        fill="#062147"
        d="M23 17a1 1 0 0 0 0-2h-.964l.106-.881a1 1 0 0 0-.874-1.112.997.997 0 0 0-1.112.874L20.022 15h-3.135l.106-.881a1 1 0 0 0-.874-1.112.997.997 0 0 0-1.112.874L14.873 15H13.5a1 1 0 0 0 0 2h1.133l-.36 3h-1.272a1 1 0 0 0 0 2h1.032l-.106.881c-.066.548.262 1.135.994 1.119a1 1 0 0 0 .991-.881L16.046 22h3.135l-.106.881c-.066.548.321 1.125.994 1.119a1 1 0 0 0 .991-.881L21.194 22h1.305a1 1 0 0 0 0-2h-1.065l.36-3H23m-3.579 3h-3.135l.36-3h3.135zM11 15v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 2 0m-2 7H5c-1.654 0-3-1.346-3-3v-6c0-1.654 1.346-3 3-3h10c.916 0 1.769.41 2.342 1.125a1 1 0 0 0 1.561-1.251A5 5 0 0 0 17 8.422V7c0-3.86-3.14-7-7-7S3 3.14 3 7v1.424A5 5 0 0 0 0 13v6c0 2.757 2.243 5 5 5h4a1 1 0 0 0 0-2M5 7c0-2.757 2.243-5 5-5s5 2.243 5 5v1H5z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-lock-hashtag_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrLockHashtag;
